module.exports = __webpack_public_path__ + "static/media/animal_06.9efe7de9.png";